// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HostsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HostsIcon" ref={forwardedRef} {...props}>
      <path d="M8.5 3v1.5h-4v4H3V3z" />
      <path d="M3 11.5V17h5.5v-1.5h-4v-4z" />
      <path d="M15.5 4.5h-4V3H17v5.5h-1.5z" />
      <path d="M15.5 11.5H17V17h-5.5v-1.5h4z" />
      <path d="M6.25 7.25a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v5.5a1 1 0 0 1-1 1h-5.5a1 1 0 0 1-1-1zm1.5 5h4.5v-4.5h-4.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HostsIcon = /* @__PURE__ */ Object.assign(HostsIconComponent, {
  displayName: 'HostsIcon',
});
